<template>
    <div class="users">
        <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>用户列表</el-breadcrumb-item>
        </el-breadcrumb>
        <div style="margin-top: 1rem; padding: 1.5rem 1rem 0 1rem; background-color: white">
            <el-form :inline="true" :model="query">
                <el-form-item label="手机号:">
                    <el-input v-model="query.phone" placeholder="手机号"></el-input>
                </el-form-item>
                <!--<el-form-item label="用户类型:">
                    <el-select v-model="query.type" placeholder="请选择">
                        <el-option
                                v-for="item in userTypes"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>-->
                <el-form-item>
                    <el-button type="primary" @click="onQuery">查询</el-button>
                    <el-button type="default" @click="query = {}">重置</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div style="margin-top: 1rem; padding: 1rem; background-color: white">
            <el-table
                    :data="users"
                    border
                    stripe
                    v-loading="loading"
                    style="width: 100%">

                <el-table-column
                        prop="openid"
                        label="openid">
                </el-table-column>
                <el-table-column
                        prop="phone"
                        label="手机号码">
                </el-table-column>
                <el-table-column
                        prop="createTime"
                        label="注册时间">
                </el-table-column>

                <el-table-column
                        prop="level"
                        label="操作">
                    <template slot-scope="scope">
                        <el-button @click="$router.push('/user/edit?id=' + scope.row.id)" type="text" size="small">编辑</el-button>
<!--                        <el-button @click="$router.push('/user/address?id=' + scope.row.id)" type="text" size="small">配送地址</el-button>-->
<!--                        <el-button @click="deleteUser(scope.row.id)" type="text" size="small">删除</el-button>-->
                    </template>
                </el-table-column>

            </el-table>
            <div style="text-align: center">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="pagination.page"
                        :page-sizes="[10, 20, 50, 100, 200]"
                        :page-size="pagination.pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total">
                </el-pagination>
            </div>
        </div>
    </div>
</template>
<script>
    import userApi from "../../api/user";
    export default {
        data: function () {
            return {
                users: [],
                loading: false,
                total: 0,
                pagination: {
                    page: sessionStorage.getItem("page") || 1,
                    pageSize: 10
                },
                query: {

                },
            }
        },
        mounted() {
            this.loadUsers();
        },
        methods: {
            deleteUser: function(id) {
                this.$confirm('确定删除该用户？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.loading = true;
                    userApi.deleteById(id).then(result => {
                        this.loading = false;
                        this.loadUsers();
                    })
                });
            },
            changeLevel: function(row) {
                this.loading = true;
                userApi.updateLevel(row.id, row.level).then(result => {
                    this.loading = false;
                    this.loadUsers();
                })
            },
            changeStatus: function(row) {
                this.loading = true;
                let status = row.status ? 0 : 1
                userApi.updateStatus(row.id, status).then(result => {
                    this.loading = false;
                    this.loadUsers();
                })
            },
            loadUsers: function () {
                this.loading = true;
                userApi.getAll(this.query, this.pagination).then(result => {
                    this.loading = false;
                    this.users = result.data;
                    this.total = result.total;
                })
            },
            onQuery: function () {
                this.pagination = {
                    page: 1,
                    pageSize: 10
                }
                this.loadUsers();
            },
            handleSizeChange: function (size) {
                this.pagination = {
                    page: 1,
                    pageSize: size
                }
                this.loadUsers();
            },
            handleCurrentChange: function (page) {
                sessionStorage.setItem("page", page);
                this.pagination = {
                    ...this.pagination,
                    page: page,
                }
                this.loadUsers();
            },
        }
    }
</script>
